import React, { useCallback } from 'react';
import i18n from '../../Shared/Translation/i18n.js';
import InputCont from '../../Shared/Form/InputCont.js';
import useDetail from '../../Shared/useDetail/index.js';
import { ApiUrl } from '../../project/Defines.js';
import { EVENT_NAME } from '../../project/utilities.js';

export default function Inputs() {
    const listUpdateEvent = EVENT_NAME.SALES_NETWORK_FILTERS_LIST_UPDATE;
    const reloadEvent = EVENT_NAME.SALES_NETWORK_FILTERS_LIST_LOAD;

    const { dataItem, setDataItem, updateData, validation } = useDetail({
        data: {},
        updateUrl: ApiUrl.SalesNetworkConfigUpdate,
        dataLoadUrl: ApiUrl.SalesNetworkConfigFiltersLoad,
        listUpdateEvent,
        reloadEvent
    });

    const updateSuccessCallback = useCallback(() => {
        return true;
    }, []);

    const dataChange = (e) => {
        const newData = {...dataItem, item: {...dataItem.item, [e.target.name]: e.target.checked}};

        updateData(updateSuccessCallback, null, { overrideData: { name: e.target.name, value: e.target.checked} });

        setDataItem(newData);
    }

    return <>{dataItem &&
        <div className="section_group">
        <div className="sections extra">
            <div className="form_fields"><div className="section_title"><text>{i18n("text.filters_display")}</text></div><div className="form_separator"></div></div>
            <div className="form_fields">{
                Object.keys(dataItem.item).map(key => (
                    <cont key={key}>
                        <InputCont
                            key={key}
                            label={`text.${key}`}
                            inputProps={{
                                validation, name: key, type: 'checkbox', value: dataItem.item[key], onChange: (e) => { dataChange(e) },
                                checked: dataItem.item[key]
                            }} />
                    </cont>
                ))
            }
            </div>
        </div>
    </div>
    }
    </>
}